import Keycloak, { KeycloakConfig } from "keycloak-js";
import React, {
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";

const initKeycloak = async (config: KeycloakConfig) => {
  const keycloak = new Keycloak(config);
  const authenticated = await keycloak.init({ onLoad: "login-required" });
  if (!authenticated) throw new Error("Authentication failed");
  return keycloak;
};

type KeycloakContext = { keycloak: Keycloak };

const context = React.createContext<KeycloakContext | null>(null);
export const useKeycloak = () => {
  const value = useContext(context);
  if (!value)
    throw new Error(
      "useKeycloak may only be used in a child element of KeycloakAuth",
    );
  return value;
};

type Props = PropsWithChildren<{
  config: KeycloakConfig;
}>;

export const KeycloakAuth: FC<Props> = (props) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [instance, setInstance] = useState<Keycloak | null>(null);

  useEffect(() => {
    if (instance) return;
    initKeycloak(props.config).then(
      (keycloakInstance) => {
        setInstance(keycloakInstance);
        setAuthenticated(true);
      },
      (err) => {
        // handle error
        console.error(err);
      },
    );
  }, []);

  return authenticated && instance ? (
    <context.Provider value={{ keycloak: instance }}>
      {props.children}
    </context.Provider>
  ) : (
    <h2></h2>
  );
};